import Vue from 'vue';

const state = Vue.observable({
  wasOpen: false, // Попап был открыт, но не должен был быть закрыт
});

export const getters = {
  wasOpen: () => state.wasOpen,
};

export const mutations = {
  setWasOpen(v) {
    state.wasOpen = !!v;
  },
};
